import AdministrationProjects from './AdministrationProjects'

export default AdministrationProjects
